import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";

const RegisterModal = ({ isOpen, onClose, onSwitchToLogin }) => {
  const { register } = useAuth();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    acceptTerms: false,
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isRegistered, setIsRegistered] = useState(false);
  const ERROR_MESSAGES = {
    "User already registered": "Ya existe una cuenta con el mismo correo.",
    default: "Ocurrió un error al registrarte. Intenta de nuevo.",
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ============================================
  // HANDLE SUBMIT - CON DEBUG FORZADO
  // ============================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");
    setIsLoading(true);

    // Validaciones
    if (!formData.fullName.trim()) {
      setError("El nombre completo es requerido");
      setIsLoading(false);
      return;
    }

    if (!formData.email.trim()) {
      setError("El correo electrónico es requerido");
      setIsLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres");
      setIsLoading(false);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Las contraseñas no coinciden");
      setIsLoading(false);
      return;
    }

    if (!formData.acceptTerms) {
      setError("Debes aceptar los términos y condiciones");
      setIsLoading(false);
      return;
    }

    console.log("🚀 ===== ENVIANDO REGISTRO =====");
    console.log("📧 Email:", formData.email);
    console.log("👤 Nombre:", formData.fullName);
    console.log("📱 Teléfono:", formData.phone);

    try {
      const result = await register(formData.email, formData.password, {
        name: formData.fullName,
        phone: formData.phone || "",
      });

      console.log("📦 RESULTADO COMPLETO:", result);
      console.log("✅ Success:", result?.success);
      console.log("👤 User:", result?.user);

      if (result && result.success === true) {
        console.log("🎉 REGISTRO EXITOSO - Activando isRegistered");
        setSuccessMessage(
          result.message ||
            "Registro exitoso. Ya puedes acceder a la plataforma."
        );
        setIsRegistered(true); // 👈 ESTO ES CRÍTICO
        setIsLoading(false);
      } else {
        console.log("❌ REGISTRO FALLÓ:", result?.error);
        const rawMessage = result.error?.message || result.error;
        const translatedError =
          ERROR_MESSAGES[rawMessage] || ERROR_MESSAGES["default"];

        setError(translatedError);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("💥 ERROR INESPERADO:", error);
      setError(ERROR_MESSAGES["default"]);
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
    setIsLoading(false);
    setIsRegistered(false);
    setSuccessMessage("");
    setError("");
    setFormData({
      fullName: "",
      email: "",
      password: "",
      confirmPassword: "",
      phone: "",
      acceptTerms: false,
    });
  };

  const handleSwitchToLogin = () => {
    onClose();
    onSwitchToLogin();
    setIsLoading(false);
    setIsRegistered(false);
    setSuccessMessage("");
    setError("");
    setFormData({
      fullName: "",
      email: "",
      password: "",
      confirmPassword: "",
      phone: "",
      acceptTerms: false,
    });
  };

  const handleCloseToLanding = () => {
    onClose(); // Solo cierra el modal, App.jsx mostrará el landing automáticamente
    setIsLoading(false);
    setIsRegistered(false);
    setSuccessMessage("");
    setError("");
    setFormData({
      fullName: "",
      email: "",
      password: "",
      confirmPassword: "",
      phone: "",
      acceptTerms: false,
    });
  };
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] overflow-y-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-slate-900/95 via-indigo-900/95 to-slate-900/95 backdrop-blur-md" />

      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-md transform overflow-hidden rounded-3xl bg-white shadow-2xl animate-slideUp">
          {/* Barra superior - CAMBIA DE COLOR CUANDO REGISTRA */}
          <div
            className={`absolute top-0 left-0 right-0 h-2 bg-gradient-to-r transition-all duration-500 ${
              isRegistered
                ? "from-emerald-500 via-green-500 to-teal-500"
                : "from-emerald-500 via-teal-500 to-cyan-500"
            }`}
          />
          <button
            onClick={handleCloseToLanding}
            className="absolute top-4 right-4 p-2 rounded-full hover:bg-slate-100 transition-colors z-10"
            aria-label="Cerrar y volver al inicio"
          >
            <svg
              className="w-6 h-6 text-slate-400 hover:text-slate-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div className="px-8 pt-10 pb-8">
            {/* Icono - CAMBIA CUANDO REGISTRA */}
            <div className="flex justify-center mb-6">
              <div
                className={`p-4 rounded-2xl shadow-lg transition-all duration-500 transform ${
                  isRegistered
                    ? "bg-gradient-to-br from-emerald-500 to-green-600 scale-110 shadow-emerald-300"
                    : "bg-gradient-to-br from-emerald-600 to-teal-600 shadow-emerald-200"
                }`}
              >
                {isRegistered ? (
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12l2 2 4-5m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                ) : (
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20c0-3.314 2.686-6 6-6h4c3.314 0 6 2.686 6 6v1H3v-1z"
                    />
                  </svg>
                )}
              </div>
            </div>

            {/* Título */}
            <h2 className="text-3xl font-black text-center text-slate-800 mb-2 transition-all duration-500">
              {isRegistered ? "🎉 ¡Registro exitoso!" : "Crear cuenta"}
            </h2>
            <p className="text-center text-slate-500 mb-8">
              {isRegistered
                ? "Tu cuenta ha sido creada correctamente"
                : "Comienza tu camino a la certificación"}
            </p>

            {/* ========== PANTALLA DE ÉXITO ========== */}
            {isRegistered && (
              <div className="mb-6 p-6 bg-gradient-to-br from-emerald-50 to-teal-50 border-2 border-emerald-200 rounded-2xl animate-fade">
                <div className="flex flex-col items-center text-center">
                  <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mb-4 border-4 border-emerald-200">
                    <svg
                      className="w-10 h-10 text-emerald-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                  </div>

                  <span className="text-lg font-bold text-emerald-800 block mb-3">
                    {successMessage || "¡Registro completado!"}
                  </span>

                  <div className="bg-white/80 backdrop-blur-sm px-6 py-4 rounded-xl border border-emerald-200 w-full mb-6">
                    <p className="text-xs text-emerald-600 uppercase tracking-wider mb-1">
                      Conectate con tu usuario:
                    </p>
                    <p className="text-sm font-bold bg-emerald-100 px-3 py-2 rounded-lg text-emerald-800 font-bold">
                      {formData.email}
                    </p>
                  </div>

                  <div className="w-full space-y-3 mt-2">
                    <button
                      onClick={handleSwitchToLogin}
                      className="w-full py-4 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white font-black rounded-xl shadow-lg shadow-emerald-200 transition-all transform hover:scale-[1.02]"
                    >
                      Ir al inicio de sesión
                    </button>
                    <button
                      onClick={handleClose}
                      className="w-full py-4 bg-white border-2 border-emerald-200 text-emerald-700 font-bold rounded-xl hover:bg-emerald-50 transition-all"
                    >
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ========== MENSAJE DE ERROR ========== */}
            {error && !isRegistered && (
              <div className="mb-6 p-4 bg-red-50 border-2 border-red-200 rounded-xl flex items-start gap-3 animate-fade">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg
                    className="w-5 h-5 text-red-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <span className="text-sm text-red-700 flex-1">{error}</span>
              </div>
            )}

            {/* ========== FORMULARIO DE REGISTRO ========== */}
            {!isRegistered && (
              <form onSubmit={handleSubmit} className="space-y-4">
                {/* Nombre completo */}
                <div>
                  <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
                    Nombre completo
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 pl-4 flex items-center text-slate-400">
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>
                    </span>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="Tu nombre completo"
                      disabled={isLoading}
                      className="w-full pl-12 pr-4 py-3 bg-slate-50 border-2 border-slate-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-0 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                      required
                    />
                  </div>
                </div>

                {/* Email */}
                <div>
                  <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
                    Correo electrónico
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 pl-4 flex items-center text-slate-400">
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </span>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="tu@email.com"
                      disabled={isLoading}
                      className="w-full pl-12 pr-4 py-3 bg-slate-50 border-2 border-slate-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-0 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                      required
                    />
                  </div>
                </div>

                {/* Teléfono */}
                <div>
                  <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
                    Teléfono <span className="text-slate-300">(opcional)</span>
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 pl-4 flex items-center text-slate-400">
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        />
                      </svg>
                    </span>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+507 6000-0000"
                      disabled={isLoading}
                      className="w-full pl-12 pr-4 py-3 bg-slate-50 border-2 border-slate-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-0 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                    />
                  </div>
                </div>

                {/* Contraseña */}
                <div>
                  <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
                    Contraseña
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 pl-4 flex items-center text-slate-400">
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                        />
                      </svg>
                    </span>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="••••••••"
                      disabled={isLoading}
                      className="w-full pl-12 pr-4 py-3 bg-slate-50 border-2 border-slate-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-0 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                      required
                    />
                  </div>
                </div>

                {/* Confirmar contraseña */}
                <div>
                  <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
                    Confirmar contraseña
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 pl-4 flex items-center text-slate-400">
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9 12l2 2 4-5m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                        />
                      </svg>
                    </span>
                    <input
                      type="password"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      placeholder="••••••••"
                      disabled={isLoading}
                      className="w-full pl-12 pr-4 py-3 bg-slate-50 border-2 border-slate-200 rounded-xl text-sm focus:bg-white focus:border-emerald-500 focus:ring-0 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                      required
                    />
                  </div>
                </div>

                {/* Términos */}
                <label className="flex items-start gap-3 cursor-pointer group">
                  <input
                    type="checkbox"
                    name="acceptTerms"
                    checked={formData.acceptTerms}
                    onChange={handleChange}
                    disabled={isLoading}
                    className="mt-1 w-4 h-4 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed"
                  />
                  <span className="text-xs text-slate-600 group-hover:text-slate-800 transition-colors">
                    Acepto los{" "}
                    <a
                      href="/legal#terms"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-bold text-emerald-600 hover:text-emerald-800 underline decoration-emerald-200 underline-offset-2"
                    >
                      Términos y Condiciones
                    </a>{" "}
                    y la{" "}
                    <a
                      href="/legal#privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-bold text-emerald-600 hover:text-emerald-800 underline decoration-emerald-200 underline-offset-2"
                    >
                      Política de Privacidad
                    </a>
                  </span>
                </label>

                {/* Botón submit */}
                <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full py-4 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white font-black rounded-2xl shadow-lg shadow-emerald-200 transition-all transform hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 flex items-center justify-center gap-2"
                >
                  {isLoading ? (
                    <>
                      <span className="w-5 h-5 border-3 border-white border-t-transparent rounded-full animate-spin" />
                      Creando cuenta...
                    </>
                  ) : (
                    "Registrarse"
                  )}
                </button>
              </form>
            )}
          </div>
          {/* Login */}
          <p className="text-center text-sm text-slate-600 pb-8">
            ¿Ya estás registrado?{" "}
            <button
              onClick={handleSwitchToLogin}
              className="font-bold text-green-600 hover:text-green-800 transition-colors"
            >
              Inicia sesión
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterModal;
